export const Alert_Screen_Close_TXT = []
Alert_Screen_Close_TXT["en"] = "This screen will close."
Alert_Screen_Close_TXT["th"] = "หน้าจอกำลังจะปิดลง"

export const Helper_Screen_Close_TXT = []
Helper_Screen_Close_TXT["en"] = "Don't worry, we're going to close this screen. and takes you back to the Line page to select the next menu"
Helper_Screen_Close_TXT["th"] = "ท่านไม่ต้องกังวลเรากำลังจะปิดหน้าจอนี้ลง และนำท่านกลับไปยังหน้า Line เพื่อเลือกเมนูต่อไป"
